export enum TaskSortOption {
    StartDate = 0,
    Subject = 1
}
